define(
	'Digi.DigiConfigSettings.DigiConfigSettings.Checkout',
    [
        'Digi.DigiConfigSettings.DigiConfigSettings',
		'GoVirtualOffice.HideItemOption.HideItemOption',
		'GoVirtualOffice.LoginRegHTMLMessage.LogLoginRegHTMLMessageinOriginRedirect'
	],
    function (
        DigiConfigSettings,
		GoVirtualOfficeHideItemOption,
		GoVirtualOfficeLoginRegHTMLMessage
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (application) {

			var layout;
			var environment;
			var config;
			var OrderWizardModulePaymentMethodSelector;

			DigiConfigSettings.mountToApp(application);
			GoVirtualOfficeHideItemOption.mountToApp(application);
			GoVirtualOfficeLoginRegHTMLMessage.mountToApp(application);

			layout = application.getComponent('Layout');
			environment = application.getComponent('Environment');

			config = environment.getConfig('digiConfigSettings');

			if (config && config.register) {

				if (config.register.loginRegisterMessage) {
					layout.addToViewContextDefinition('LoginRegister.View', 'digiLoginRegisterMessage', 'string', function () {
						return config.register.loginRegisterMessage;
					});
				}

				if (config.register.registerSubtitle) {
					layout.addToViewContextDefinition('LoginRegister.View', 'digiRegisterSubtitle', 'string', function () {
						return config.register.registerSubtitle;
					});
				}

				if (config.register.registerText) {
					layout.addToViewContextDefinition('LoginRegister.Register.View', 'digiRegisterText', 'string', function () {
						return config.register.registerText;
					});
				}

				if (config.register.disableRegistration) {
					layout.addToViewContextDefinition('LoginRegister.View', 'showRegister', 'boolean', function(context) {
						return false;
					});
					layout.addToViewContextDefinition('LoginRegister.View', 'showRegisterOrGuest', 'boolean', function(context) {
						return false;
					});
				}
			}

			if (config && config.checkout) {

				if (config.checkout.defaultCCPayment) {

					OrderWizardModulePaymentMethodSelector = require('OrderWizard.Module.PaymentMethod.Selector');

					if (
						OrderWizardModulePaymentMethodSelector
						&& OrderWizardModulePaymentMethodSelector.prototype
						&& _.isFunction(OrderWizardModulePaymentMethodSelector.prototype.initialize)
					) {
						OrderWizardModulePaymentMethodSelector.prototype.initialize = _.wrap(OrderWizardModulePaymentMethodSelector.prototype.initialize, function (fn) {
							fn.apply(this, _.toArray(arguments).slice(1));
							this.setModuleByType('creditcard', true);
						});
					}
				}
			}
		}
	};
});
